
eval("define(\'text!orodatagrid/templates/board/column-view.html\',[],function () { return \'<div class=\"board-card-list\"></div>\\n\';});\n\n//# sourceURL=/text!orodatagrid/templates/board/column-view.html");

